import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const DraftNotice = ({ t }) => (
  <div className="mb-8 rounded-lg border-l-4 border-amber-400 bg-amber-50 p-4 text-amber-900">
    <p className="font-bold">{t('legal.draftNotice.label')}</p>
    <p className="mt-1 text-sm leading-relaxed">{t('legal.draftNotice.body')}</p>
  </div>
);

const CookiesPolicy = () => {
  const { t } = useTranslation();
  const s = 'legal.cookies.sections';

  const categories = t(`${s}.categories.items`, { returnObjects: true });
  const manageItems = t(`${s}.manage.items`, { returnObjects: true });

  return (
    <>
      <SEO
        path="/cookies-policy"
        title={t('legal.cookies.seo.title')}
        description={t('legal.cookies.seo.description')}
        keywords={t('legal.cookies.seo.keywords')}
      />
      <Header />
      <main className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-8 rounded-xl shadow-lg animate-fade-in animate-slide-up">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">{t('legal.cookies.title')}</h1>
            <p className="text-gray-600 mb-4">{t('legal.cookies.lastUpdated')}</p>

            <DraftNotice t={t} />

            <div className="prose prose-green max-w-none">
              <h2>{t(`${s}.intro.heading`)}</h2>
              <p>{t(`${s}.intro.p1`)}</p>
              <p>
                {t(`${s}.intro.p2`)}{' '}
                <a href="/privacy-policy">{t(`${s}.intro.linkText`)}</a>.
              </p>

              <h2>{t(`${s}.what.heading`)}</h2>
              <p>{t(`${s}.what.p1`)}</p>
              <p>{t(`${s}.what.p2`)}</p>

              <h2>{t(`${s}.categories.heading`)}</h2>
              <p>{t(`${s}.categories.intro`)}</p>
              {(Array.isArray(categories) ? categories : []).map((item) => (
                <div key={item.title} className="not-prose my-4 rounded-lg border border-gray-200 p-4">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <h3 className="m-0 text-base font-bold text-gray-900">{item.title}</h3>
                    <span className="rounded-full bg-csl-green/10 px-3 py-1 text-xs font-semibold text-csl-green">
                      {item.consent}
                    </span>
                  </div>
                  <p className="mt-2 mb-0 text-sm text-gray-600">{item.description}</p>
                </div>
              ))}

              <h2>{t(`${s}.consent.heading`)}</h2>
              <p>{t(`${s}.consent.p1`)}</p>
              <p className="text-sm italic text-amber-700">{t(`${s}.consent.toolNote`)}</p>

              <h2>{t(`${s}.manage.heading`)}</h2>
              <p>{t(`${s}.manage.intro`)}</p>
              <ul>
                {(Array.isArray(manageItems) ? manageItems : []).map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <p className="text-sm italic text-amber-700">{t(`${s}.manage.toolNote`)}</p>

              <h2>{t(`${s}.updates.heading`)}</h2>
              <p>{t(`${s}.updates.p1`)}</p>

              <h2>{t(`${s}.contact.heading`)}</h2>
              <p>{t(`${s}.contact.p1`)}</p>
              <p>
                <strong>{t(`${s}.contact.emailLabel`)}:</strong> {t(`${s}.contact.emailValue`)}<br />
                <strong>{t(`${s}.contact.addressLabel`)}:</strong> {t(`${s}.contact.addressValue`)}
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default CookiesPolicy;
